import { render, staticRenderFns } from "./InfoMoveView.vue?vue&type=template&id=6c5817d6&scoped=true"
import script from "./InfoMoveView.vue?vue&type=script&lang=js"
export * from "./InfoMoveView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5817d6",
  null
  
)

export default component.exports